(function ($, Global) {
    function ArticlePage() {
        // Déclaration class objet
    }

    ArticlePage.prototype.initEvents = function () {
        this.publishers();
    };

    ArticlePage.prototype.publishers = function () {
        $(document).on('click', '.page-article .article .article-header img,.page-article .article .article-body .img-wrapper img,.page-article .article .article-chapo img,.page-article .article .illustration img', function () {
            var windowWidth = $(window).width();
            if (windowWidth >= Global.viewports.sm) {
                var $img = $(this);
                var $parent = $img.parent();
                var caption = $img.attr('title') || '';
                var src = $img.attr('src');
                var params = $.getParams(src);
                var imgResize = new Global.ImageResize(params);

                if ($parent.tagName() === 'FIGURE') {
                    var $caption = $parent.find('figcaption');
                    if ($caption.exists()) caption = $caption.html();
                }

                imgResize.width = 1200;

                $.Topic('modal-img-fullscreen-load').publish(imgResize.getSrc(), caption);
            }
        });
    };

    Global.ArticlePage = ArticlePage;

}(jQuery, window));